export default __webpack_public_path__ + "static/media/contactImage.33a21b0e.jpg";